import { FC } from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled from 'styled-components';
import { ExternalLink } from '../atoms/link';
import { Paragraph } from '../atoms/paragraph';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${({ theme }): string => theme.mixins.margin({ top: 8.5, bottom: 4 })};
`;

const WrittenBy = styled(Paragraph)`
  ${({ theme }): string => theme.mixins.margin({ bottom: 7 })};
`;

const Description = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

const ImageContainer = styled.div`
  ${({ theme }): string => theme.mixins.margin({ right: 1.75, bottom: 3.5 })};
  min-width: 50px;
`;

const FindARole = styled(Paragraph)`
  ${({ theme }): string => theme.mixins.margin({ top: 0 })};
`;

export const Bio: FC = () => {
  const bio = useStaticQuery<Queries.BioQuery>(graphql`
    query Bio {
      avatar: file(absolutePath: { regex: "/lm-logo.png/" }) {
        childImageSharp {
          gatsbyImageData(layout: FIXED, placeholder: BLURRED)
        }
      }
      site {
        siteMetadata {
          author
          social {
            twitter
          }
        }
      }
    }
  `);
  const { author, social } = bio.site!.siteMetadata;

  return (
    <Container>
      <WrittenBy>
        Written by <strong>{author}</strong> folks, who live for the holidays.{' '}
        <ExternalLink href={social.twitter}>You should follow us on Twitter</ExternalLink>.
      </WrittenBy>
      <Description>
        <ImageContainer>
          <GatsbyImage
            style={{ width: 50, height: 50 }}
            imgStyle={{ borderRadius: '100%' }}
            image={bio.avatar!.childImageSharp!.gatsbyImageData}
            alt={author}
          />
        </ImageContainer>
        <FindARole>
          Want to express your love for travel and tech? Well, you could read another article, or you could just come
          and join us. We’re always looking for talent to help us enrich the lives of travellers -{' '}
          <ExternalLink href="https://careers.lastminute.com/jobs?utm_source=TechBlog">
            find your role here
          </ExternalLink>
          .
        </FindARole>
      </Description>
    </Container>
  );
};
